import { QueovalBase, QueovalDate, QueovalDik } from "../global";
import { Corporation, Person } from './action-co.model';
import { PropertyData } from '../bodisplay/bodisplay.model';
import { ActionCoLigneDevis } from './action-co-devis.model';
import { Select } from "../utilities";
import { BoProperty, IBoProperty } from "../bodisplay/dynamictags-inline/dynamictags-inline.model";


export class ActionCoCalculatorModel extends QueovalBase {
  constructor() {
    super();
    //this.ActiveTab = new ActionCoCalculatorTab();
    this.Tabs = new Array<ActionCoCalculatorTab>();
    //this.UnlinkedTabs = new Array<ActionCoCalculatorTab>();

    this.Mission = new ActionCoCalculatorMission();
    this.Obligations = new Array<ActionCoMissionPDCGrouped>();
    this.Properties = new Array<ActionCoMissionProperty>();
    this.Questions = new Array<ActionCoMissionQuestion>();
    this.Groups = new Array<ActionCoMissionGroup>();
    this.Collaborateurs = new Array<ActionCoCollaborateurMission>();
    this.Client = new Corporation();
    this.SaveMontantMission = false;
  }
  public Ident: string;
  public Amount: number;
  public Discount: number;
  public SaveMontantMission: boolean;
  //public ActiveTab: ActionCoCalculatorTab;
  public Tabs: Array<ActionCoCalculatorTab>;
  //public UnlinkedTabs: Array<ActionCoCalculatorTab>;
  public Mission: ActionCoCalculatorMission;
  public Obligations: Array<ActionCoMissionPDCGrouped>;
  public Properties: Array<ActionCoMissionProperty>;
  public Questions: Array<ActionCoMissionQuestion>;
  public Groups: Array<ActionCoMissionGroup>;
  public Collaborateurs: Array<ActionCoCollaborateurMission>;
  public Client: Corporation;
  public StrXml: string;
}

export class ActionCoCollaborateurMission extends Select
{
    public Cout: number;
}

export class ActionCoMissionCAC {
  constructor() {
    this.Values = new Array<ActionCoMissionCACRow>();
  }
  public FourchetteHeures: string;
  public UnitPriceSI: number;
  public TotalAmountSI: number;
  public UnitPriceRM: number;
  public TotalAmountRM: number;
  public UnitPriceJN: number;
  public TotalAmountJN: number;
  public UnitPriceSN: number;
  public TotalAmountSN: number;
  public Discount: number;
  public TotalAmountHT: number;
  public Values: Array<ActionCoMissionCACRow>;
}
export class ActionCoMissionCACRow {
  public Label: string;
  public MissionHours: number;
  public HoursSI: number;
  public HoursRM: number;
  public HoursJN: number;
  public HoursSN: number;
}

export class ActionCoCalculatorTab {
  public TabLabel: string;
  public CodeBo: string;
  public Ident: string;
  public IdRelation: string;
  public Info: string;
  public IsProjet: boolean;
  public BoModels: Array<QueovalDik>;
  public SelectedBoModel: string;
  public Linked: boolean;
  constructor() {
    this.Ident = '0';
  }
}
export class ActionCoCalculatorMission extends ActionCoCalculatorTab{
  constructor() {
    super();
    this.Groups = new Array<ActionCoMissionGroup>();
   
    this.IdRelation = '0';
    this.Cacs = new ActionCoMissionCAC();
    this.globalInformationGroup = new ActionCoMissionGroup();

    this.loadingDatas = false;
  }
  public Label: string;
  public BoName: string;
  public Discount: number;
  public Amount: number;  
  public Groups: Array<ActionCoMissionGroup>;
  public globalInformationGroup: ActionCoMissionGroup;
  public ClientsProperties: Array<ActionCoMissionProperty>;
  public MissionsProperties: Array<ActionCoMissionProperty>;
  public ObligationsProperties: Array<ActionCoMissionPDCGrouped>;
  public Cacs: ActionCoMissionCAC;
  public loadingDatas: boolean;
}

export class ActionCoMissionGroup {
  constructor() {
    this.Questions = new Array<ActionCoMissionQuestion>();
    this.Visible = false;
    this.PreLoadVisibility = false;
    this.Amount = 0;
  }
  public Ident: string;
  public Label: string;
  public Description: string;
  public Discount: number;
  public Amount: number;
  public Order: number;
  public Questions: Array<ActionCoMissionQuestion>;
  public Displayed: boolean;
  public Visible: boolean;
  public PreLoadVisibility: boolean;
  public ShowCalculGroup: boolean;
}
export class ActionCoMissionQuestion {
  constructor() {
    this.ActiveTab = 'MISSION';
    this.Obligations = new Array<ActionCoMissionPDCGrouped>();
    this.Properties = new Array<ActionCoMissionProperty>();
    this.QuoteLine = new ActionCoLigneDevis();
    this.Visible = true;
    this.PreLoadVisibility = true;
    this.ShowCalculQuestion = false;
    this.Amount = 0;
  }
  public Ident: string;
  public Label: string;
  public Description: string;
  public Amount: number;
  public Order: number;
  public Properties: Array<ActionCoMissionProperty>;
  public ActiveTab: string;
  public Obligations: Array<ActionCoMissionPDCGrouped>;
  public UsedInTheMissionCalculation: boolean;
  public QuoteLine: ActionCoLigneDevis;
  public Displayed: boolean;
  public Visible: boolean;
  public PreLoadVisibility: boolean;
  public ShowCalculQuestion: boolean;
}

export class ActionCoMissionProperty {
  public Order: number;
  public Value: PropertyData;
}

export class ActionCoMissionPDCGrouped {
  constructor() {
    this.BillingMethod = '2';
  }
  public Order: number;
  public IdDonnee: string;
  public Id: string;
  public Code: string;
  public Label: string;
  public Collaborateur: string;
  public Description: string;
  public Values: Array<ActionCoMissionPDC>;  
  public Duration: number;
  public Quantity: number;
  public DurationPrice: number;
  public QuantityPrice: number;
  public Discount: number;
  public Amount: number ;
  public BillingMethod: string;
  public LabelCommentaire: string;
  public Valide: string;
  public IdentUnique: string;
  public isPdc: boolean;

}
export class ActionCoMissionPDC {
  constructor() {

  }
  public Ident: string;
  public Info: string;
  public Code: string;
  public Duration: string;
  public Date: string;
  public Days: string;
  public Frequency: string;
  public Quantity: string;
  public BoProperties: Array<IBoProperty<any>>;
}
